import moment from "moment";
import { formatBRL } from "../../../utils/Utils";

export const renderGraficoData = (data) => {
    return {
        labels: data.label,
        datasets: [
            {
                label: "Faturamento",
                data: data.data,
                fill: false,
                backgroundColor: "#3E4095",
                borderColor: "#3E4095",
                yAxisID: "meses",
                xAxisID: "data",
                tension: 0,
            },
        ],
    };
};

export const renderGraficoOptions = () => {
    return {
        responsive: true,
        scales: {
            xAxes: [
                {
                    id: "data",
                    position: "bottom",
                    ticks: {
                        callback: function(value) {
                            return moment(value).format("MMM[']YY");
                        },
                    },
                },
            ],
            yAxes: [
                {
                    id: "meses",
                    position: "left",
                    ticks: {
                        beginAtZero: true,
                        color: "#495057",
                        precision: 0,
                        callback: function(value) {
                            return formatBRL(value);
                        },
                    },
                },
            ],
        },
        legend: {
            display: false,
        },
        tooltips: {
            callbacks: {
                title: function(item, data) {
                    return moment(data.labels[item[0].index]).format("MMM[']YY");
                },
                label: function(item) {
                    return formatBRL(item.yLabel);
                },
            },
        },
    };
};
